module.exports = __webpack_public_path__ + "img/cashier-icon-08.43077a3e.png";